import { useEffect, useState } from "react";

export default function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector("#site-footer");
      if (!footer) {
        setIsVisible(false);
        return;
      }

      const footerTop = footer.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      setIsVisible(footerTop <= windowHeight && footerTop >= 0);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className={`fixed left-1/2 bottom-5 z-50 -translate-x-1/2 flex h-12 w-12 items-center justify-center rounded-full bg-[#0C8AC4] text-white shadow-2xl transition-opacity duration-300 ease-out ${
        isVisible ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6"
      >
        <path d="M18 15l-6-6-6 6" />
      </svg>
    </button>
  );
}
